<template>
    <div>
        <router-link :to="{ name: 'selectContent', query: { source_uri: contentUri, title: contentTitle } }"
            class="text-decoration-none">
            <div class="content-tile">
                <div class="content-tile__thumbnail content-tile__thumbnail--default rounded-lg">
                    <div class="content-tile-thumbnail__cover rounded-lg" :style="{ backgroundImage: `url(${thumbnailUri})` }"></div>
                </div>
                <div class="content-tile__body content-tile-body">
                    <div class="content-tile-body__title ellipsis1">{{ contentTitle }}</div>
                    <div class="content-tile-body__lead ellipsis1">{{ decodeText(contentLead) }}</div>
                    <div class="content-tile-body__desc ellipsis1">{{ decodeText(contentDesc) }}</div>
                    <div v-if="dateTime" class="content-tile-body__timestamp">{{ formatData(dateTime) }}</div>
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>
import helper from '../assets/js/helper';
export default {
    name: 'ArticleSecondary',
    props: [
        'contentUri',
        'thumbnailUri',
        'contentTitle',
        'contentLead',
        'contentDesc',
        'dateTime'
    ],
    data: () => ({}),
    // コンポーネントマウントリスナ
    async mounted() { },
    methods: {
        decodeText(text) {
            return helper.decodeHtmlEscape(helper.removeHtmlTags(text));
        },
        formatData(datetime){
            return helper.formatDate(datetime)
        }
    }
}
</script>

<style scoped>
.content-tile {
    display: flex;
    gap: 8px;
    width: 100%;
    box-sizing: border-box;
}

.content-tile__thumbnail {
    width: 90px;
    aspect-ratio: 1;
    background-color: #eee;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}

.content-tile__thumbnail--default {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-color: #aaa;
    background-image: url('../assets/images/empty.gif');
}

.content-tile-thumbnail__cover {
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}

.content-tile__body {
    width: calc(100% - 98px);
}

.content-tile-body {
    display: flex;
    flex-flow: column;
    text-align: left;
    ;
}

.content-tile-body__title {}

.content-tile-body__lead {
    color: #444;
    font-size: 0.9em;
}

.content-tile-body__desc {
    color: #777;
    font-size: 0.8em;
}

.content-tile-body__timestamp {
    font-size: 0.8em;
    color: #777;
    margin-top: auto;
}
</style>
